import { render, staticRenderFns } from "./gallery-feedback.vue?vue&type=template&id=7f9bb751&scoped=true&"
import script from "./gallery-feedback.vue?vue&type=script&lang=ts&"
export * from "./gallery-feedback.vue?vue&type=script&lang=ts&"
import style0 from "./gallery-feedback.vue?vue&type=style&index=0&id=7f9bb751&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9bb751",
  null
  
)

export default component.exports